import axios from 'axios';
import { createApi, retry } from '@reduxjs/toolkit/query/react';

const getRequestConfig = args => {
    if (typeof args === 'string') {
        return { url: args };
    }

    return args;
};

export const axiosBaseQuery = () => {
    return async (args, api, extraOptions) => {
        const requestConfig = getRequestConfig(args);
        try {
            const response = await axios({
                ...requestConfig,
                signal: api.signal,
                ...extraOptions,
            });
            return { data: response };
        } catch (error) {
            return { error };
        }
    };
};

export const appApi = createApi({
    reducerPath: 'appApi',
    baseQuery: retry(axiosBaseQuery(), { maxRetries: 0 }),
    tagTypes: [
        'Fund',
        'Role',
        'me',
        'User',
        'Company',
        'Subscription',
        'CapitalCall',
        'Repoting',
        'CapitalAccount',
        'Notification',
        'Payment',
        'Network',
        'Document',
        'Distributor',
        'DistributorBills',
        'Closing',
        'Tunnel',
        'SGP',
        'Question',
        'Answer',
        'Action',
        'Condition',
        'ShareCategory',
        'ShareSubcategory',
        'NAV',
    ],
    endpoints: () => ({}),
});
